import React, { FC, useEffect } from "react";
import { CloseButton, Toast, ToastContainer } from "react-bootstrap";
import { CheckCircle } from "react-bootstrap-icons";

type Props = {
  isShow: boolean;
  setShow: any;
  message: string;
  isSeenClose?: boolean;
  background?: string;
  text?: string;
  check?: boolean;
  classes?: string;
};
export const CustomToast: FC<Props> = ({
  isShow,
  setShow,
  message,
  isSeenClose = true,
  background = "bg-dark",
  text = "text-white fw-400",
  check = false,
  classes = "",
}) => {
  const closeToast = () => {
    if (isShow) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (isShow) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 5000);

      return () => {
        clearTimeout(timer);
        setShow(false);
      };
    }
  }, [isShow, setShow]);

  return (
    <ToastContainer
      position="bottom-center"
      className={`position-fixed pb-5 ${classes}`}
    >
      <Toast
        show={isShow}
        onClose={closeToast}
        className={`border-0 ${background}`}
        style={{ width: "fit-content", boxShadow: "none" }}
      >
        <Toast.Body className="d-flex align-items-center py-3 pe-3 ps-4">
          {check && <CheckCircle size={18} color="green" className="me-2" />}
          <p className={`m-0 ${text}`} style={{ fontSize: "18px" }}>
            {message}
          </p>
          {isSeenClose && (
            <CloseButton
              onClick={closeToast}
              style={{
                width: "0.4rem",
                height: "0.4rem",
                filter: "invert(1)",
                opacity: "1",
                marginLeft: "15px",
              }}
            />
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};
